import * as React from 'react';
import { 
    Box, 
    Typography, 
    CircularProgress,
    TextField,
    Divider,
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
    IconButton,
    Button
} from '@mui/material';
import KeyboardReturnIcon from '@mui/icons-material/KeyboardReturn';
import CachedIcon from '@mui/icons-material/Cached';

import { Orders, Parts } from '../../../../../controllers';
import { Main } from '../index';
import { Order, Part } from './index';

export default function Detail({handleChange, itemProps}) {

    const { order } = itemProps;

    const [loading, isLoading] = React.useState(true);
    const [orderInfo, setOrder] = React.useState(undefined);
    const [partsInfo, setParts] = React.useState(undefined);
    const [partOrOrders, setPartOrOrders] = React.useState(false);

    React.useEffect(() => {
        handleInit();
    },[]);

    const handleInit = async() => {
        isLoading(true);
        await getOrderInfo();
        await getPartsInfo();
        isLoading(false);
    }

    const getOrderInfo = async() => {
        const response = await Orders.GetDetailFull(order);

        if(!response.success){
            console.log('Error Fetching order info');
            return;
        }

        setOrder(response.result);
    }

    const getPartsInfo = async() => {
        const response = await Parts.GetDetailFullByOrder(order);

        if(!response.success){
            console.log('Error Fetching parts info');
            return;
        }

        setParts(response.result);
    }

    return(
        <Box
            sx={{
                display: 'flex',
                flexDirection: 'column',
                height: '90vh',
                width: '82.5vw'
            }}
        >
            <Box
                sx={{
                    display: 'flex',
                    flexDirection: 'row',
                    justifyContent: 'space-between'
                }}
            >
                <Box
                    sx={{
                        display: 'flex',
                        flexDirection: 'row',
                    }}
                >
                    <IconButton onClick={() => handleChange(Main, {})}>
                    <KeyboardReturnIcon/>
                        </IconButton>
                    <Typography variant='h5'>Order Detail {order}</Typography>  
                </Box>   
                
                <Box
                    sx={{
                        display: 'flex',
                        flexDirection: 'row',
                    }}
                >
                    <Button onClick={() => setPartOrOrders(false)}>Show Order Info</Button>
                    <Button onClick={() => setPartOrOrders(true)}>Show Parts Info</Button>
                    <IconButton color='error' onClick={handleInit}>
                        <CachedIcon />
                    </IconButton>
                </Box>   
            </Box>

            <Divider sx={{minWidth:'100%', marginY: 1}}></Divider>

            {loading && (
                <Box
                    sx={{
                        minWidth:'100%',
                        display: 'flex',
                        flexDirection: 'column',
                        alignItems: 'center',
                    }}
                >
                    <Typography variant='h6'>Loading Info ...</Typography>
                    <CircularProgress />
                </Box>
            )}

            {(!loading && orderInfo && !partOrOrders) && (
                <Order orderInfo={orderInfo} reload={handleInit}/>
            )}
            
            {(!loading && partsInfo && partOrOrders) && (
                <Part partsInfo={partsInfo} reload={handleInit}/>
            )}
        </Box>
    );
}